const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
    // Custom code for product page goes here

    setTimeout(function() {
      if (window.location.href.indexOf('?waitlist') > -1) {
        if (document.querySelector('#mhaRnProduct button').length >0) {
          document.querySelector('#mhaRnProduct button').click();
        }
        let searchParams = window.location.href.replace('?waitlist', '');
        history.pushState({ searchParams }, '', `${window.location.pathname}`);
      }
    },1500);
    
    window.scrollToSmoothly = function(pos, time) {
        var currentPos = window.pageYOffset;
        var start = null;
        if(time == null) time = 500;
        pos = +pos, time = +time;
        window.requestAnimationFrame(function step(currentTime) {
            start = !start ? currentTime : start;
            var progress = currentTime - start;
            if (currentPos < pos) {
                window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
            } else {
                window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
            }
            if (progress < time) {
                window.requestAnimationFrame(step);
            } else {
                window.scrollTo(0, pos);
            }
        });
    }
    
    document.querySelector('#ssw-avg-rate-profile-html[data-product-id]')?.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        window.scrollToSmoothly(document.querySelector('#ssw-widget-recommends-html').offsetTop, 100);
    });

    if (document.querySelector('.subscription-upsell-wrapper') != null) {
      document.querySelector('.subscription-upsell-wrapper').addEventListener('click', (e) => {
        if (e.currentTarget.classList.contains('selected')) {
          e.currentTarget.classList.remove('selected');
        } else {
          e.currentTarget.classList.add('selected');
        }
      });
    }
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

document.querySelector('[data-products-images-sticky]').style.top = document.querySelector('#shopify-section-header').offsetHeight + 'px';